export const getInsightsProductPath = () =>
  `${window.location.origin}/insights/product`;
